import {Injectable} from '@angular/core';
import {Router} from '@angular/router';

import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';

import {Observable} from 'rxjs';
import {tap} from 'rxjs/internal/operators/tap';

import * as moment from 'moment';

import {HttpStatusCodesEnum, AuthApiService} from '@spa/api';

import {CacheCollectionService} from '../services';

import {ErrorMessageIdSelector} from '../../../assets/descriptors';
import {CommonMessages} from '../../../assets/messages/common.messages';

import {environment} from '../../../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private readonly protectedApiHeader: string;

    constructor(
        private cacheCollectionService: CacheCollectionService,
        private authenticationService: AuthApiService,
        protected router: Router
    ) {
        this.protectedApiHeader = environment.customProtectedApiHeader;
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (request.headers.has(this.protectedApiHeader)) {
            const authenticatedUser = this.authenticationService.getAuthenticatedUser();

            if (!authenticatedUser) {
                this.router.navigate(['/authentication', 'login'])
                    .finally();
            }

            const httpHeaders = request.headers
                .delete(this.protectedApiHeader)
                .append('Authorization', 'Bearer ' + authenticatedUser.accessToken);

            request = request.clone({
                headers: httpHeaders
            });
        }


        return next.handle(request).pipe(
            tap(
                null,
                (error: HttpErrorResponse) => {
                    if ([HttpStatusCodesEnum.Unauthorized, HttpStatusCodesEnum.Forbidden].indexOf(error.status) >= 0) {
                        const timestamp = moment().unix();

                        this.cacheCollectionService.addItem(
                            timestamp.toString(),
                            [error.status === HttpStatusCodesEnum.Unauthorized
                                ? CommonMessages.UnauthorizedError.message
                                : CommonMessages.ForbiddenError.message]
                        );

                        this.router.navigate(['/error'], {
                            queryParams: {
                                [ErrorMessageIdSelector]: timestamp
                            }
                        }).finally();
                    }
                }
            )
        );
    }
}
